export default {
  toolbar_lang: {
    languages: {
      english: "อังกฤษ",
      thai: "ไทย",
    },
    uat: "ระบบทดสอบ",
    role: "ผู้ขอสินเชื่อ (Seller)",
    profile: "ข้อมูลส่วนตัว",
    logout: "ออกจากระบบ",
    listmenu: {
      dashboard: "แดชบอร์ด",
      account: "บัญชีสินเชื่อ",
      buyer: "รายชื่อลูกหนี้การค้า",
      import: "นำเข้าเอกสาร",
      disbursement: "รายการโอนสิทธิเรียกร้อง",
      status: "ตรวจสอบสถานะ",
      rejecthistory: "ประวัติการยกเลิกใบแจ้งหนี้",
      report: "รายงาน",
      invoiceReport: "รายงานทั้งหมด",
      reportCancel: "รายงานการยกเลิก",
      reportReject: "รายงานการถูกปฏิเสธ",
      importOnline: "นำเข้าเอกสารแบบ Online",
      importExcel: "นำเข้าเอกสารแบบ Excel",
      importEtax: "นำเข้าเอกสารอิเล็กทรอนิกส์",
      requestorg: "ขอเข้าบริษัท",
      approve: "รายการรอการอนุมัติ",
      gotoetax: "e-Tax Invoice & e-Receipt",
      billingrpt: "Billing RPT",
      payment: "ชำระค่าบริการ",
      consider: "พิจารณาสินเชื่อเบื้องต้น",
      notifyCount: "รายการเกินกำหนดชำระ",
      otherservice: "บริการอื่นๆ",
    },
    listappbarmenu: {
      admin: "ตั้งค่าผู้ใช้งานระบบ",
      surway: "แบบสำรวจความพึงพอใจ",
    },
    transactionList: "รายการธุรกรรม",
    otherList: "อื่นๆ",
  },
  admintoolbar_lang: {
    languages: {
      english: "อังกฤษ",
      thai: "ไทย",
    },
    uat: "ระบบทดสอบ",
    role: "ผู้ขอสินเชื่อ (Seller)",
    profile: "ข้อมูลส่วนตัว",
    logout: "ออกจากระบบ",
    listmenu: {
      requestorg: "ขอเข้าองกรณ์",
      settingca: "จัดการใบรับรองอิเล็กทรอนิกส์",
      rolePermission: "จัดการบทบาท",
      roleSetting: "กำหนดสิทธิ",
      log: "บันทึกกิจกรรม",
      notification: "การแจ้งเตือน",
      update: "อัปเดตสถานะเอกสาร",
    },
    backtouser: "กลับสู่หน้าหลักของผู้ขอสินเชื่อ",
    admin: "ผู้ดูแลระบบ (Seller)",
  },
  admin_update_lang: {
    title: "อัปเดตสถานะเอกสาร",
    close: "ปิด",
    open: "เปิด",
    p1: "ทางระบบจะทำการส่งสถานะเอกสารในรูปแบบ",
    p2: "<url>/EfactoringLog/ConfirmStatus/<serller_taxid>/<sk_id ที่ได้รับหลังจากการส่งใบแจ้งหนี้มาที่ระบบ efactoring>/<invoice_id>",
    p3: "ตัวอย่างเช่น",
    p4: "https://example-url.com/EfactoringLog/ConfirmStatus/0100037xxxxx/3e715454d-8898-4429-9efb-dddf2eebe220/INV-TEST0001",
  },
  admin_role_setting_lang: {
    title: "กำหนดสิทธิ",
    table: {
      pic: "รูปภาพ",
      name: "ชื่อ-นามสกุล",
      oneid: "OneID",
      email: "อีเมล",
      typeEmployee: "ประเภทพนักงาน",
      position: "ตำแหน่ง",
      permission: "กำหนดสิทธิ",
      super: "ผู้ดูแลระบบ",
      itemsPerPage: "จำนวนแสดงผล",
    },
    dialog: {
      username: "Username",
      role: "บทบาท",
      status: "สถานะ",
      remove: "ลบ",
    },
    admin: "ผู้ดูแลระบบ",
    user: "ผู้ใช้งานทั่วไป",
    nodata: "ไม่มีข้อมูล",
  },
  admin_log: {
    title: "บันทึกกิจกรรม",
    filter: "ตัวกรอง",
    labelSearch: "ค้นหากิจกรรม",
    table: {
      date: "วันที่และเวลา",
      name: "ผู้ใช้",
      type: "หมวดหมู่",
      activity: "กิจกรรม",
      itemsPerPage: "จำนวนแสดงผล",
    },
    startDate: "วันที่",
    toDate: "ถึง",
    invoice: "เลขที่เอกสาร",
    searchBtn: "ค้นหากิจกรรม",
    clearBtn: "เคลียร์",
  },
  admin_role_permission_lang: {
    title: "จัดการบทบาท",
    table: {
      name: "ชื่อบทบาท",
      count: "จำนวน",
      action: "จัดการ",
    },
    addBtn: "เพิ่มบทบาท",
  },
  add_role_lang: {
    title: "สร้างบทบาท",
    cancelBtn: "ยกเลิก",
    addBtn: "เพิ่มบทบาท",
    roleDetail: "รายละเอียดบทบาท",
    roleName: "ชื่อบทบาท",
    permission: {
      view: "ดูเท่านั้น",
      download: "ดาวน์โหลดข้อมูล",
      ced: "สร้าง/แก้ไข/ลบ",
      upload: "อัปโหลดข้อมูล",
      approve: "ผู้อนุมัติ",
    },
    page: {
      account: "บัญชีลูกหนี้การค้า",
      import: "นำเข้าใบแจ้งหนี้",
      disbursement: "รายการโอนสิทธิเรียกร้อง",
      status: "ตรวจสอบสถานะ",
      report: "รายงาน",
    },
  },
  admin: {
    notificationtitle: "จัดการการแจ้งเตือน",
    notificationemail: "รับการแจ้งเตือนผ่าน E-Mail",
    notificationchat: "รับการแจ้งเตือนผ่าน OneChat",
    settingdialogemail: "ตั้งค่ารับการแจ้งเตือนผ่าน Email",
    settingdialogchat: "ตั้งค่ารับการแจ้งเตือนผ่าน OneChat",
    hq: "สำนักงานใหญ่",
    branch: "สาขา",
    branchno: "เลขที่สาขา",
    sender: "ผู้ส่ง",
    recipient: "ผู้รับ",
    recipientlist: "รายชื่อผู้รับ",
    name: "ชื่อ",
  },
  profile_lang: {
    profileUserTitle: "ข้อมูลผู้ใช้งาน (Seller)",
    profileBusiness: "ข้อมูลบริษัท (Seller)",
    accountId: "เลขประจำตัวผู้ใช้",
    username: "ชื่อผู้ใช้",
    nameTh: "ชื่อ-นามสกุล (ไทย)",
    nameEng: "ชื่อ-นามสกุล (อังกฤษ)",
    email: "อีเมล (One Platform)",
    businessId: "เลขประจำตัวบริษัท",
    taxId: "เลขประจำตัวผู้เสียภาษี 13 หลัก",
    businessnameTh: "ชื่อบริษัท (ไทย)",
    businessnameEng: "ชื่อบริษัท (อังกฤษ)",
  },
  account_lang: {
    accountTitle: "บัญชีสินเชื่อ",
    enable: "เปิดใช้งาน",
    disable: "ปิดใช้งาน",
    headerTable: {
      contractId: "เลขที่สัญญา",
      factorName: "ชื่อบริษัท",
      contactPerson: "ชื่อ-นามสกุล ผู้ติดต่อ",
      contactTel: "เบอร์ติดต่อ",
      contractStatus: "สถานะของสัญญา",
    },
    listtotal: "รายการ",
  },
  dashboard_lang: {
    dashboardTitle: "แดชบอร์ด",
    baht: " บาท",
    amount: "มูลค่า Finance",
    transactions: "จำนวนใบแจ้งหนี้",
    nowithdrwl: "ไม่มีข้อมูลการเบิกสินเชื่อ",
    withdraw: "การเบิกครั้งที่",
    withdrawTitle: "จำนวนครั้งการเบิกสินเชื่อ",
    invoiceStatus: "สถานะใบแจ้งหนี้",
    paidStatus: "อัตราการชำระเงินคืน (%)",
    lastopendoc: "เอกสารที่ทำการเปิดล่าสุด",
    donutLabel: "ทั้งหมด", // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตามเพราะมันเป็นรูป
    headerTable: {
      issuedate: "วันที่ดำเนินการ",
      invoiceid: "เลขที่ใบแจ้งหนี้",
      buyername: "ชื่อลูกหนี้การค้า",
      buyerid: "เลขผู้เสียภาษีลูกหนี้การค้า",
      amount: "จำนวนเงิน",
      duedate: "กำหนดชำระ",
      poref: "เลขที่ใบสั่งซื้อ",
    },
    search: "ค้นหา",
    nodata: "ไม่มีข้อมูล",
  },
  importonline_lang: {
    title: "นำเข้าเอกสารแบบ (Online)",
    detail: "รายละเอียดเอกสาร",
    form: {
      type: "ประเภท",
      ref: "อ้างอิงใบแจ้งหนี้เลขที่",
      buyername: "ชื่อลูกหนี้การค้า",
      buyerid: "เลขผู้เสียภาษีลูกหนี้การค้า",
      invoiceid: "เลขที่เอกสาร",
      issuedate: "เอกสารลงวันที่",
      duedate: "วันครบกำหนดชำระ",
      amount: "จำนวนเงิน",
      poref: "เลขที่ใบสั่งซื้อ",
      attachment: "ไฟล์เอกสาร",
      reason: "เหตุของการทำรายการ",
      original: "มูลค่าเดิม",
      correct: "มูลค่าที่ถูกต้อง",
      dif: "ผลต่าง (มูลค่าใบลดหนี้)",
    },
    label: {
      buyername: "กรุณากรอกชื่อลูกหนี้การค้า",
      buyerid: "กรุณากรอกเลขผู้เสียภาษีลูกหนี้การค้า",
      invoiceid: "กรุณากรอกเลขที่ใบแจ้งหนี้",
      issuedate: "กรุณากรอกวันที่เอกสาร",
      duedate: "กรุณากรอกวันที่กำหนดชำระ",
      amount: "0.00 (หน่วยบาท)",
      amount2: "กรุณากรอกจำนวนเงิน",
      poref: "กรุณากรอกเลขที่ใบสั่งซื้อ",
      attachment: "คลิกเพื่อแนบไฟล์",
      reason: "กรุณากรอกเหตุของการทำรายการ",
      original: "0.00 (หน่วยบาท)",
      correct: "0.00 (หน่วยบาท)",
      dif: "0.00 (หน่วยบาท)",
      diftext: "กรุณากรอกผลต่าง",
    },
    table: {
      type: "ประเภท",
      date: "วันที่ดำเนินการ",
      invoiceid: "เลขที่เอกสาร",
      buyername: "ชื่อลูกหนี้การค้า",
      buyerid: "เลขผู้เสียภาษีลูกหนี้การค้า",
      amount: "จำนวนเงิน",
      issuedate: "วันที่เอกสาร",
      duedate: "กำหนดชำระ",
      poref: "เลขที่ใบสั่งซื้อ",
      invref:'อ้างอิงใบแจ้งหนี้เลขที่',
      attachment: "เอกสารแนบ",
      edit: "แก้ไข",
      remove: "ลบ",
      more: "จัดการ",
      reason: "เหตุของการทำรายการ",
      original: "มูลค่าเดิม",
      correct: "มูลค่าที่ถูกต้อง",
      dif: "ผลต่าง (มูลค่าใบลดหนี้)",
    },
  },
  importexcel_lang: {
    importExcelTitle: "นำเข้าใบแจ้งหนี้ (Excel)",
    importExcelTitleCdn: "นำเข้าใบลดหนี้ (Excel)",
    importFile: "ไฟล์ที่ต้องการนำเข้า",
    remarkRequest: "** รองรับเฉพาะไฟล์ Excel (.xlsx) เท่านั้น",
    statusImportTable: "สถานะรายการนำเข้าใบแจ้งหนี้",
    importBtn: "นำเข้าใบแจ้งหนี้",
    importBtnCredit: "นำเข้าใบลดหนี้",
    clearBtn: "เคลียร์",
    FormExample: "ตัวอย่างแบบฟอร์ม",
    downloadBtn: "ดาวน์โหลดแบบฟอร์ม",
    remark: "หมายเหตุ",
    remarkText:
      "การนำเข้าข้อมูลโดย Excel ให้ดำเนินการดาวน์โหลดแบบฟอร์ม และใช้รูปแบบตามที่กำหนดเท่านั้น",
    importCount: " รายการ",
    nodata: "ไม่มีข้อมูล",
    headerTable: {
      invoiceId: "เลขที่ใบแจ้งหนี้",
      docidt: "เลขที่เอกสาร",
      buyerTaxId: "ลูกหนี้การค้า",
      amount: "จำนวนเงิน",
      issueDate: "วันที่ใบแจ้งหนี้",
      dueDate: "กำหนดชำระ",
      status: "สถานะ",
      message: "รายละเอียด",
    },
    // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตาม
    rules: {
      require: "กรุณาเลือกไฟล์",
      wrongtype: "ไฟล์ผิดประเภท",
    },
    textfield: {
      header:
        "คุณสามารถเพิ่มเอกสารทีละหลาย ๆ รายการได้ด้วยการอัปโหลดไฟล์ Excel เข้ามาโดยมีขั้นตอนดังนี้",
      header2:
        "คุณสามารถเพิ่มลูกหนี้การค้าทีละหลาย ๆ รายการได้ด้วยการอัปโหลดไฟล์ Excel เข้ามาโดยมีขั้นตอนดังนี้",
      line1:
        "1. จัดเตรียมไฟล์ Excel ให้อยู่ในรูปแบบที่ระบบกำหนด โดยสามารถดาวน์โหลดแบบฟอร์ม ตัวอย่างได้จากด้านล่างนี้",
      line2: "ดาวน์โหลดแบบฟอร์ม Excel",
      line3:
        "2. เลือกไฟล์ Excel ของคุณที่จัดเตรียมไว้ แล้วคลิก ต่อไป เพื่อตรวจสอบข้อมูล",
      line4: "วางไฟล์ที่ต้องการอัปโหลดที่นี่",
      line5: "หรือ",
      line6: "เลือกไฟล์",
      line7: "จากคอมพิวเตอร์ของคุณ",
    },
    process: "กำลังดำเนินการ",
    success: "ดำเนินการสำเร็จ",
    error: {
      title: "พบข้อผิดพลาด ",
      list: " รายการ มูลค่า ",
      baht: " บาท",
      from: " จาก ",
    },
  },
  dialogimportetax_lang: {
    importetaxTitle: "นำเข้าเอกสารอิเล็กทรอนิกส์",
    importBtn: "ดำเนินการต่อ",
    closeBtn: "ปิด",
    cancelBtn: "ยกเลิก",
    disbursement: "รายการโอนสิทธิเรียกร้อง",
  },
  importetax_lang: {
    importetaxTitle: "นำเข้าเอกสารอิเล็กทรอนิกส์",
    fileBtn: "นำเข้าไฟล์ PDF/XML",
    condition: "เงื่อนไขในการค้นหาเอกสาร",
    searchBtn: "ค้นหาข้อมูล",
    clearBtn: "เคลียร์",
    documentTypeItems: {
      all: "ทั้งหมด",
      doc380: "ใบแจ้งหนี้",
      doc388: "ใบกำกับภาษี",
      docT02: "ใบแจ้งหนี้/ใบกำกับภาษี",
      docT03: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
      docT04: "ใบส่งของ/ใบกำกับภาษี",
    },
    importBtn: "นำเข้าข้อมูล",
    searchForm: {
      docdatefrom: "เอกสารลงวันที่",
      processdatefrom: "วันที่ส่งเอกสาร",
      todate: "ถึง",
      sellerbranchId: "เลขที่สาขาผู้ขาย",
      buyername: "ชื่อผู้ซื้อ",
      buyerbranchId: "เลขที่สาขาผู้ซื้อ",
      buyerTaxId: "เลขประจำตัวผู้เสียภาษีผู้ซื้อ",
      docform: "เลขที่ใบแจ้งหนี้",
      docto: "ถึง",
      doctype: "ประเภทเอกสาร",
    },
    totalcount: " รายการ",
    nodata: "ไม่มีข้อมูล",
    headerTable: {
      documenttype: "ประเภทเอกสาร",
      sellerbranchId: "เลขที่สาขาผู้ขาย",
      documentId: "เลขที่เอกสาร",
      documentDate: "วันที่เอกสาร",
      buyerId: "เลขประจำตัวผู้ซื้อ",
      buyerbranchId: "เลขที่สาขาผู้ซื้อ",
      buyerName: "ชื่อผู้ซื้อ",
      amount: "จำนวนเงิน",
    },
  },
  report_lang: {
    reportTitle: "รายงานทั้งหมด",
    reportCancelTitle: "รายงานการยกเลิก",
    reportRejectTitle: "รายงานการถูกปฏิเสธ",
    condition: "เงื่อนไขในการค้นหาเอกสาร",
    searchForm: {
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      invoiceId: "เลขที่ใบแจ้งหนี้",
      lastupdateDate: "วันที่ดำเนินการ",
      todate: "ถึง",
      issueDate: "วันที่ใบแจ้งหนี้",
      duedate: "วันครบกำหนดชำระ",
      factorName: "ชื่อผู้ให้สินเชื่อ",
      lastCancel: "วันที่เอกสาร",
    },
    status: "สถานะ",
    groupInvoice: "เลขที่กลุ่มใบแจ้งหนี้",
    clearBtn: "เคลียร์",
    searchBtn: "ค้นหา",
    downloadBtn: "ดาวน์โหลดรายงาน",
    counttotal: " รายการ",
    viewstatus: "คลิกเพื่อดูเอกสารแนบ",
    headerTable: {
      groupId: "เลขที่กลุ่มใบแจ้งหนี้",
      debitgroupId: "เลขที่กลุ่มใบลดหนี้",
      lastupdate: "วันที่ดำเนินการ",
      invoiceId: "เลขที่ใบแจ้งหนี้",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      amount: "จำนวนเงิน",
      actual_amount: "ยอดรับซื้อจริง",
      purchaserate: "อัตราการรับซื้อ",
      issueDate: "วันที่ใบแจ้งหนี้",
      dueDate: "กำหนดชำระ",
      status: "สถานะ",
      factorName: "ชื่อผู้ให้สินเชื่อ",
      lastCancel: "วันที่ยกเลิก",
      timeCancel: "เวลาที่ยกเลิก",
      remark: "หมายเหตุ",
      sellerUpdate: "ผู้ทำรายการ",
      lastReject: "วันที่ปฏิเสธ",
      timeReject: "เวลาที่ปฏิเสธ",
      sentDate: "วันที่ SENT",
      postedDate: "วันที่ POST",
      cancelledDate: "วันที่ CANCEL",
      rejectedDate: "วันที่ REJECT",
      paidDate: "วันที่ PAID",
      indisputedDate: "วันที่ INDISPUTED",
      financedDate: "วันที่ FINANCE",
      reassign_date: "วันที่ RE-ASSIGN",
      repayment_date: "วันที่ RE-PAYMENT",
      checkAll: "เลือกทั้งหมด",
      selectTable: "เลือกตาราง",
      docDate: "เอกสารลงวันที่",
      oldAmount: "มูลค่าเดิม",
      newAmount: "มูลค่าที่ถูกต้อง",
      diffAmount: "ผลต่าง(มูลค่าใบลดหนี้)",
      refInv: "อ้างอิงใบแจ้งหนี้",
      remarkRef: "เหตุผลของการทำรายการ",
      acceptedDate: "วันที่ Accepted",
      rejectRemark: "เหตุผลของการปฏิเสธ",
      creditNoteId: "เลขที่ใบลดหนี้",
      issueDatedebit: "วันที่ใบลดหนี้",
    },
  },
  dialogViewStatusDetail_lang: {
    statusTitle: "สถานะใบแจ้งหนี้",
    sented: "รอดำเนินการ",
    post: "ตรวจสอบแล้วอยู่ระหว่างการพิจารณา",
    approve: "กำลังพิจารณาอนุมัติสินเชื่อ",
    finance: "อนุมัติสินเชื่อ",
    complete: "เสร็จสิ้นกระบวนการ",
    paid: "ชำระเงินแล้ว",
    indisputed: "หนี้สงสัยจะสูญ",
    waitindisputed: "รอการอนุมัติหนี้สงสัยจะสูญ",
    boterror: "พบข้อมูลการขอสิ้นเชื่อซ้ำซ้อน",
    duplicate: "พบข้อมูลการลงทะเบียนแล้ว",
    exists: "พบข้อมูลการขอสินเชื่อซ้ำซ้อน",
    expired: "ใบแจ้งหนี้เกินกำหนดชำระ",
    closeBtn: "ปิด",
  },
  disbursement_lang: {
    disbursementTitle: "รายการโอนสิทธิเรียกร้อง",
    detailSort: "วันที่ใบแจ้งหนี้",
    transferBtn: "โอนสิทธิเรียกร้อง",
    search: "ค้นหา",
    counttotal: " รายการ",
    nodata: "ไม่มีข้อมูล",
    moreOptions: {
      view: "ดูเอกสาร",
      upload: "แนบไฟล์",
      download: "ดาวน์โหลด",
      edit: "แก้ไข",
      delete: "ลบ",
    },
    debitheaderTable: {
      issueDate: "เอกสารลงวันที่",
      invoiceId: "เลขที่เอกสาร",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      dueDate: "วันครบกำหนดชำระ",
      old_amount: "มูลค่าเดิม",
      new_amount: "มูลค่าที่ถูกต้อง",
      diff_amount: "ผลต่าง (มูลค่าใบลดหนี้)",
      attachment: "เอกสาร",
      ref: "อ้างอิงใบแจ้งหนี้เลขที่",
      reason: "เหตุของการทำรายการ",
      option: "จัดการข้อมูล",
      no: "ลำดับ",
      invoice: "ใบแจ้งหนี้",
    },
    headerTable: {
      issueDate: "เอกสารลงวันที่",
      invoiceId: "เลขที่เอกสาร",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      dueDate: "วันครบกำหนดชำระ",
      amount: "จำนวนเงิน",
      attachment: "เอกสาร",
      detail: "รายละเอียด",
      option: "จัดการข้อมูล",
    },
    completeInfo: "ข้อมูลครบถ้วน",
    incompleteInfo: "ข้อมูลไม่ครบ",
    filter: {
      condition: "เงื่อนไขการค้นหา",
      beginissue: "วันที่เอกสาร",
      to: "ถึง",
      duedate: "วันครบกำหนดชำระ",
      invoiceid: "เลขที่ใบแจ้งหนี้",
      buyerid: "เลขผู้เสียภาษีลูกหนี้การค้า",
      buyername: "ชื่อลูกหนี้การค้า",
    },
  },
  rejecthistory_lang: {
    counttotal: " รายการ",
    rejecthistoryTitle: "ประวัติการยกเลิกใบแจ้งหนี้",
    headerTable: {
      invoiceId: "เลขที่ใบแจ้งหนี้",
      buyerId: "เลขประจำตัวผู้ซื้อ",
      buyerName: "ชื่อผู้ซื้อ",
      issueDate: "วันที่ใบแจ้งหนี้",
      amount: "จำนวนเงิน",
      dueDate: "วันครบกำหนดชำระ",
      status: "สถานะ",
    },
  },
  dialogViewAttachment_lang: {
    viewTitle: "รายการเอกสารแนบใบแจ้งหนี้",
    counttotal: " รายการ",
    nodata: "ไม่มีเอกสารแนบ",
  },
  dialogUploadAttachment_lang: {
    uploadTitle: "อัปโหลดเอกสาร",
    invoiceId: "ใบแจ้งหนี้เลขที่",
    creditId: "ใบลดหนี้เลขที่",
    labelText:
      "ลากไฟล์มาวางไว้ที่นี่ หรือ <span class='filepond--label-action'>คลิกเพื่ออัปโหลด</span>",
    download: "ดาวน์โหลด",
    otherAttachment: "เอกสารอื่นๆ",
  },
  dialogDownloadAttachment_lang: {
    downloadTitle: "ดาวน์โหลดใบแจ้งหนี้",
    remark: "หมายเหตุ",
    text: "สามารถดาวน์โหลด e-Invoice ได้เฉพาะรายการที่ทำวันที่ 11 สิงหาคม 2564 เป็นต้นไป",
    download: "ดาวน์โหลด",
    closeBtn: "ปิด",
  },
  dialogUpdateAttachment_lang: {
    updateTitle: "แก้ไขรายการโอนสิทธิเรียกร้อง",
    updateTitleDebit: "แก้ไขรายละเอียดใบลดหนี้",
    closeBtn: "ปิด",
    updateBtn: "บันทึก",
    form: {
      issueDate: "วันที่ใบแจ้งหนี้",
      dueDate: "วันครบกำหนดชำระ",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขที่ผู้เสียภาษีลูกหนี้การค้า",
      invoiceId: "เลขที่ใบแจ้งหนี้",
      amount: "จำนวนเงิน",
      poref: "เลขที่ใบสั่งซื้อ",
      status: "สถานะ",
    },
    formDebit: {
      creditNoteId: "เลขที่เอกสาร",
      issueDate: "เอกสารลงวันที่",
      invoiceId: "อ้างอิงใบแจ้งหนี้เลขที่",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      remark: "เหตุของการทำรายการ",
      old_amount: "มูลค่าเดิม",
      new_amount: "มูลค่าที่ถูกต้อง",
      diff_amount: "ผลต่าง (มูลค่าใบลดหนี้)",
    },
  },
  dialogGroup_lang: {
    groupTitle: "โอนสิทธิเรียกร้อง",
    nodata: "ไม่มีข้อมูล",
    factorName: "เลือกผู้ให้สินเชื่อ",
    cancelBtn: "ยกเลิก",
    closeBtn: "ปิด",
    submitBtn: "ยืนยัน",
    headerTable: {
      status: "สถานะ",
      issueDate: "วันที่ใบแจ้งหนี้",
      invoiceId: "เลขที่ใบแจ้งหนี้",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      dueDate: "วันครบกำหนดชำระ",
      amount: "จำนวนเงิน",
      purchaserate: "อัตราการรับซื้อ",
      poref: "เลขที่ใบสั่งซื้อ",
      delete: "นำออก",
    },
    headerTableDebit: {
      status: "สถานะ",
      issueDate: "วันที่ใบลดหนี้",
      invoiceId: "เลขที่ใบลดหนี้",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      old_amount: "มูลค่าเดิม",
      new_amount: "มูลค่าที่ถูกต้อง",
      diff_amount: "ผลต่าง (มูลค่าใบลดหนี้)",
      purchaserate: "อัตราการรับซื้อ",
      poref: "เลขที่ใบแจ้งหนี้",
      delete: "นำออก",
    },
    totalcount: "จำนวนสิทธิเรียกร้อง",
    countText: "สิทธิ",
    totalAmount: "รวมของทั้งหมด",
    baht: "บาท",
  },
  statusGetListInGroup_lang: {
    statusTitle: "ตรวจสอบสถานะ",
    search: "ค้นหา",
    counttotal: " รายการ",
    nodata: "ไม่มีข้อมูล",
    viewstatus: "คลิกเพื่อดูเอกสารแนบ",
    headerTable: {
      issueDatedebit: "วันที่ใบลดหนี้",
      issueDate: "วันที่ใบแจ้งหนี้",
      invoiceId: "เลขที่เอกสาร",
      buyerId: "เลขประจำตัวลูกหนี้การค้า",
      buyerName: "ชื่อลูกหนี้การค้า",
      amount: "จำนวนเงิน",
      actual_amount: "ยอดรับซื้อจริง",
      purchaserate: "อัตราการรับซื้อ",
      dueDate: "วันครบกำหนดชำระ",
      overDate: "เกินกำหนด (วัน)",
      attachment: "เอกสาร",
      status: "สถานะ",
      option: "จัดการข้อมูล",
      verify: "การยืนยัน",
      docDate: "เอกสารลงวันที่",
      docId: "เลขที่เอกสาร",
      oldAmount: "มูลค่าเดิม",
      newAmount: "มูลค่าที่ถูกต้อง",
      diffAmount: "ผลต่าง (มูลค่าใบลดหนี้)",
      ref: "อ้างอิงใบแจ้งหนี้เลขที่",
      remark: "เหตุผลของการทำรายการ",
      delete: "ลบ",
    },
    attachment: "เอกสารแนบ",
    overdue: "เกินกำหนด",
    revoke: "เพิกถอน",
    verifyBtn: "ยืนยันเอกสาร",
    moreOptions: {
      add: "เพิ่มหนี้/ลดหนี้",
      upload: "แนบเอกสาร",
      revoke: "เพิกถอน",
      download: "ดาวน์โหลด",
    },
    dialog: {
      name: "ชื่อ",
      sign: "ลายเซ็น",
      btn: "ปิด",
    },
  },
  status_lang: {
    statusTitle: "ตรวจสอบสถานะ",
    filter: "ค้นหาแบบละเอียด",
    detailSort: "วันที่ดำเนินการ",
    condition: "เงื่อนไขในการค้นหาเอกสาร",
    searchForm: {
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerId: "เลขประจำตัวลูกหนี้การค้า",
      invoiceId: "เลขที่เอกสาร",
      lastupdate: "วันที่ดำเนินการ",
      todate: "ถึง",
      issueDate: "วันที่เอกสาร",
      duedate: "วันครบกำหนด",
      status: "สถานะ",
      groupId: "เลขที่กลุ่มใบแจ้งหนี้",
      amount: "จำนวนเงิน",
    },
    clearBtn: "เคลียร์",
    searchBtn: "ค้นหา",
    counttotal: " รายการ",
    nodata: "ไม่มีข้อมูล",
    viewstatus: "คลิกเพื่อดูรายละเอียด",
    headerTable: {
      issueDate: "วันที่ดำเนินการ",
      docId: "เลขที่กลุ่มใบแจ้งหนี้",
      docIddebit: "เลขที่กลุ่มใบลดหนี้",
      factorName: "ชื่อผู้ให้สินเชื่อ",
      transactions: "จำนวนใบแจ้งหนี้",
      amount: "รวมยอดทั้งหมด(บาท)",
      purchaserate: "อัตราการรับซื้อ",
      actual_amount: "ยอดรับซื้อจริง",
      quantity: "จำนวน",
      status: "สถานะ",
      delete: "ลบกลุ่ม",
      coversheet: "ใบปะหน้า",
      download: "ดาวน์โหลด",
      importby: "นำเข้าโดย",
      more: "จัดการ",
      invoiceDownload: "ใบแจ้งหนี้ทั้งหมด",
      attachmentDownload: "เอกสารแนบทั้งหมด",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      BuyerName: "ชื่อลูกหนี้การค้า",
      oldAmount: "มูลค่าเดิม",
      realAmount: "มูลค่าที่ถูกต้อง",
      diffAmount: "ผลต่าง",
      refInv: "อ้างอิงใบแจ้งหนี้",
      remark: "เหตุของการทำรายการ",
    },
    removeBtn: "ลบ",
    filterBtn: "ตัวกรอง",
    attachmentDownloadButton: {
      downloadInvoice: "ดาวน์โหลดใบแจ้งหนี้",
      downloadAttachment: "ดาวน์โหลดเอกสารแนบ",
      downloadAllDocuments: "ดาวน์โหลดเอกสารทั้งหมด",
    },
  },
  buyerDetail_lang: {
    buyerTitle: "รายละเอียดบัญชีลูกหนี้การค้า",
    search: "ค้นหา",
    addbuyer: "เพิ่มลูกหนี้การค้า",
    addwithexcel: "นำเข้าแบบ Excel",
    cantadd: "ไม่สามารถเพิ่มลูกหนี้การค้าได้ เนื่องจากสัญญาไม่ถูกเปิดใช้งาน",
    counttotal: " ราย",
    nodata: "ไม่มีข้อมูล",
    headerTable: {
      customercode: "รหัสลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      BuyerName: "ชื่อลูกหนี้การค้า",
      email: "อีเมล",
      address: "ที่อยู่",
      amount: "วงเงินการขายโอนสิทธิ",
      amountfee: "วงเงินคงเหลือ",
      pendingamount: "วงเงินที่รอดำเนินการ",
      amountexceed: "วงเงินที่ใช้เกิน",
      remark: "หมายเหตุ",
      options: "จัดการข้อมูล",
    },
    errorlist: "รายการที่ผิดพลาด",
    dialogtitle: "นำเข้าลูกหนี้การค้าแบบ Excel",
  },
  editContractBuyer_lang: {
    contractTitle: "แก้ไขลูกหนี้การค้า",
    subTitle: "ข้อมูลลูกหนี้การค้า",
    cancelBtn: "ยกเลิก",
    submitBtn: "บันทึก",
    // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตาม
    rules: {
      requireTax: "กรุณากรอกเลขผู้เสียภาษีลูกหนี้การค้า",
      requireBranch: "กรุณากรอกเลขที่สาขาลูกหนี้การค้า 5 หลัก",
      requireName: "กรุณากรอกชื่อลูกหนี้การค้า",
      requireAddress: "กรุณากรอกที่อยู่",
    },
    editForm: {
      customercode: "รหัสลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      buyerName: "ชื่อลูกหนี้การค้า(ไทย)",
      buyerNameEng: "ชื่อลูกหนี้การค้า(อังกฤษ)",
      buyerBranch: "สาขา",
      email: "อีเมล",
      address: "ที่อยู่",
      remark: "หมายเหตุ",
      customerTypeThai: "ประเภทหน่วยงาน(ไทย)",
      customerTypeEng: "ประเภทหน่วยงาน(อังกฤษ)",
      title: "รายละเอียดลูกหนี้การค้า",
      create: "สร้างลูกหนี้การค้า",
      update: "แก้ไขลูกหนี้การค้า",
      contactPerson: "ผู้ติดต่อ",
      contactTel: "เบอร์ติดต่อ",
      contactMail: "อีเมล(ผู้ติดต่อ)",
      bizType: "รูปแบบธุรกิจ",
      businessType: {
        business: "นิติบุคคล",
        citizen: "บุคคลทั่วไป",
      },
      btnRevenue: "ค้นหาจากฐานข้อมูลกรมสรรพากร",
      btnTaxID: "ค้นหาด้วยเลขประจำตัวผู้เสียภาษี",
      textRevenue: "หรือ",
      zipcode: "รหัสไปรษณีย์",
      subdistrict: "ตำบล/แขวง",
      district: "อำเภอ/เขต",
      province: "จังหวัด",
    },
    placeholder: "กรุณากรอกหมายเหตุ",
    agency: {
      gov: "หน่วยงานราชการ",
      state: "รัฐวิสาหกิจ",
      partner: "ห้างหุ้นส่วนจำกัด(หจก.)",
      company: "บริษัทจำกัด(บจก.)",
      public: "บริษัทมหาชน(บมจ.)",
      single: "กิจการเจ้าของคนเดียว",
      venture: "กิจการร่วม/กิจการร่วมค้า",
      commercial: "ทะเบียนพาณิชย์",
      store: "ร้านค้า",
      other: "อื่นๆ",
    },
  },
  accountDetail_lang: {
    contract: "รายละเอียดสัญญา",
    contractFactoring: "สินเชื่อ Factoring",
    contractPreFinance: "สินเชื่อ Pre-finance",
    accountTitle: "รายละเอียด",
    status: "สถานะของสัญญา",
    activate: "เปิดใช้งาน",
    deactivated: "ปิดใช้งาน",
    remark: "หมายเหตุ",
    contractKeeper: "ผู้ดูแลสัญญา",
    form: {
      factorname: "ผู้ให้บริการสินเชื่อ",
      platformId: "เลขประจำตัวผู้เสียภาษี",
      contactPerson: "ผู้ติดต่อ",
      contractTel: "เบอร์โทรศัพท์ผู้ติดต่อ",
      contractId: "เลขที่สัญญา",
      issueDate: "วันที่จัดทำสัญญา",
      dueDate: "กำหนดชำระ(Factoring term)",
      day: " วัน",
      amount: "วงเงินขายโอนสิทธิ",
      interestrate: "อัตราดอกเบี้ย",
      peryear: "ต่อปี",
      fee: "ค่าธรรมเนียมการขายโอนสิทธิเรียกร้อง",
      value: "ของมูลค่าโครงการ",
      entrancefee: "ค่าธรรมเนียมแรกเข้า",
      baht: "บาท",
      purchaserate: "อัตราการรับซื้อ",
      valuegood: "ของมูลค่าใบกำกับของสินค้า",
      branch: "สาขา",
      codename: "รหัสลูกค้า",
    },
    buyerList: "รายชื่อลูกหนี้การค้า",
    buyerListBtn: "แสดงรายชื่อลูกหนี้การค้า",
    finance: "ข้อมูลงบการเงิน",
    nostatement: "ไม่พบข้อมูลงบการเงิน",
    list: " รายการ",
    statement: "งบการเงิน",
    download: "ดาวน์โหลด",
    filter: "ตัวกรอง",
    search: "ค้นหา",
    table: {
      customercode: "รหัสลูกหนี้การค้า",
      buyername: "ชื่อลูกหนี้การค้า",
      branch: "สาขา",
      amount: "วงเงินลูกหนี้การค้า",
      amountremain: "วงเงินที่ใช้",
      buyertax: "เลขประจำตัวผู้เสียภาษี",
      contractId: "เลขที่สัญญา",
      lastUpdate: "วันที่ดำเนินการ",
      startDate: "วันที่เริ่มต้น",
      endDate: "วันที่สิ้นสุด",
      action: "จัดการ",
    },
  },
  addContractBuyer_lang: {
    addTitle: "เพิ่มลูกหนี้การค้า",
    subTitle: "ข้อมูลลูกหนี้การค้า",
    cancelBtn: "ยกเลิก",
    submitBtn: "ยืนยัน",
    placeholder: "กรุณากรอกหมายเหตุ",
    addForm: {
      customercode: "รหัสลูกหนี้การค้า",
      buyerId: "เลขผู้เสียภาษีลูกหนี้การค้า",
      buyerName: "ชื่อลูกหนี้การค้า",
      buyerBranch: "เลขที่สาขาลูกหนี้การค้า",
      email: "อีเมล",
      address: "ที่อยู่",
      remark: "หมายเหตุ",
    },
    // ! เปลี่ยนภาษาแล้วมันไม่เปลี่ยนตาม
    rules: {
      requireTax: "กรุณากรอกเลขผู้เสียภาษีลูกหนี้การค้า",
      requireBranch: "กรุณากรอกเลขที่สาขาลูกหนี้การค้า 5 หลัก",
      requireName: "กรุณากรอกชื่อลูกหนี้การค้า",
      requireAddress: "กรุณากรอกที่อยู่",
    },
  },
  managecad_lang: {
    headerTable: {
      name: "ชื่อ",
      taxid: "เลขประจำตัวผู้เสียภาษี",
      branch: "สาขา",
      cad: "CAD",
      action: "จัดการ",
    },
    actionMenu: {
      editcad: "จัดการ CAD",
      remove: "ลบข้อมูล",
    },
    addBtn: "เพิ่มลูกหนี้การค้า",
  },
  increase_decrease_lang: {
    title: "เพิ่มหนี้/ลดหนี้",
    titleetax: "เพิ่มหนี้/ลดหนี้อิเล็กทรอนิกส์ ",
    detail: "รายละเอียด",
    clearBtn: "เคลียร์",
    submitBtn: "บันทึก",
    exceltitle: "นำเข้าใบเพิ่มหนี้/ลดหนี้แบบ Excel",
    btn: {
      excel: "นำเข้าใบแจ้งหนี้แบบ excel",
      etax: "นำเข้าใบแจ้งหนี้อิเล็กทรอนิกส์",
    },
    form: {
      invoiceid: "เลขที่ใบแจ้งหนี้",
      buyername: "ชื่อลูกหนี้การค้า",
      issuedate: "วันที่ใบแจ้งหนี้",
      duedate: "วันที่กำหนดชำระ",
      doctype: "ประเภทเอกสาร",
      docdate: "วันที่เอกสาร",
      docid: "เลขที่เอกสาร",
      poref: "อ้างอิง",
      remark: "เหตุของการทำรายการ",
      attachment: "แนบเอกสาร",
      oldvalue: "มูลค่าใบแจ้งหนี้เดิม",
      newvalue: "มูลค่าที่ถูกต้อง",
      diff: "ผลต่าง",
    },
    doctype: {
      debit: "ใบเพิ่มหนี้",
      credit: "ใบลดหนี้",
      tradedebit: "ใบเพิ่มหนี้การค้า",
      tradecredit: "ใบลดหนี้การค้า",
      all: "ทั้งหมด",
    },
    header: {
      doctype: "ประเภทเอกสาร",
      invoiceid: "เลขที่เอกสาร",
      oldvalue: "มูลค่าตามใบแจ้งหนี้เดิม",
      newvalue: "มูลค่าที่ถูกต้อง",
      diff: "ผลต่าง",
      remark: "เหตุผลของการทำรายการ",
      attachment: "ไฟล์เอกสาร",
    },
    filter: {
      title: "ค้นหาใบแจ้งหนี้อิเล็กทรอนิกส์",
      docform: "เลขที่เอกสาร",
      docto: "ถึง",
      docdate: "วันที่เอกสาร",
    },
    newamountmore: "มูลค่าใหม่ต้องมากกว่า",
    newamountless: "มูลค่าใหม่ต้องน้อยกว่า",
  },
  approve_lang: {
    title: "รายการรออนุมัติ",
    headerTable: {
      factorname: "ชื่อผู้ให้สินเชื่อ",
      factortaxid: "เลขที่เสียภาษีผู้ให้สินเชื่อ",
      invoiceid: "เลขที่ใบแจ้งหนี้",
      buyername: "ชื่อลูกหนี้การค้า",
      buyerid: "เลขที่เสียภาษีลูกหนี้การค้า",
      detail: "รายละเอียด",
      waitingapprove: "รายการรออนุมัติ",
      action: "อนุมัติ",
      issuedate: "วันที่เอกสาร",
      amount: "จำนวนเงิน",
    },
    approveMenu: {
      disbursement: "รายการโอนสิทธิเรียกร้อง",
      status: "ตรวจสอบสถานะ",
      buyer: "บัญชีลูกหนี้การค้า",
      waittodelete: "รายการยกเลิกใบแจ้งหนี้",
    },
  },
  dialogApprove_lang: {
    headerTable: {
      invoiceid: "เลขที่เอกสาร",
      buyerid: "เลขประจำตัวลูกหนี้การค้า",
      buyername: "ชื่อลูกหนี้การค้า",
      amount: "จำนวนเงิน",
      issuedate: "วันที่เอกสาร",
      duedate: "วันครบกำหนดชำระ",
      status: "สถานะ",
      action: "อนุมัติ",
    },
    closeBtn: "ปิด",
    title: "รายละเอียด",
  },
  importetaxfile_lang: {
    selecttype: "เลือกประเภทไฟล์ในการอัปโหลด",
    listinvoice: "รายการนำเข้าใบแจ้งหนี้",
    header: {
      loading: "การดำเนินการ",
      document: "เอกสาร",
      pdf: "PDF",
      xml: "XML",
      status: "สถานะการทำงาน",
      action: "จัดการ",
      remove: "นำออก",
    },
    textfield: {
      header:
        "คุณสามารถเพิ่มใบแจ้งหนี้ทีละหลาย ๆ รายการได้ด้วยการอัปโหลดไฟล์ Excel เข้ามาโดยมีขั้นตอนดังนี้",
      line1:
        "1. จัดเตรียมไฟล์ Excel ให้อยู่ในรูปแบบที่ระบบกำหนด โดยสามารถดาวน์โหลดแบบฟอร์ม ตัวอย่างได้จากด้านล่างนี้",
      line2: "ดาวน์โหลดแบบฟอร์ม Excel",
      line3:
        "2. เลือกไฟล์ Excel ของคุณที่จัดเตรียมไว้ แล้วคลิก ต่อไป เพื่อตรวจสอบข้อมูล",
      line4: "วางไฟล์ที่ต้องการอัปโหลดที่นี่",
      line5: "หรือ",
      line6: "เลือกไฟล์",
      line7: "จากคอมพิวเตอร์ของคุณ",
    },
    status: {
      ready: "พร้อมอัปโหลด",
      notready: "ไม่พร้อมอัปโหลด",
      finish: "อัปโหลดสำเร็จ",
    },
    confirm: "ยืนยันการส่งเอกสาร",
    label: "ยืนยันการนำส่งเอกสารที่ยังไม่ได้รับการ Certs",
    dialog: {
      title: "นำเข้าใบแจ้งหนี้อิเล็กทรอนิกส์",
      progress: "กำลังดำเนินการ ",
      from: " จาก ",
      list: " รายการ",
      success: " รายการ ดำเนินการสำเร็จ",
    },
  },
  swal_lang: {
    error: "ดำเนินการไม่สำเร็จ",
    sucess: "ดำเนินการสำเร็จ",
    fail: "ไม่สามารถดำเนินการได้",
    submitBtn: "ยืนยัน",
    cancelBtn: "ยกเลิก",
    confirmBuyer: "ยืนยันการเพิ่มลูกหนี้การค้าหรือไม่ ?",
    updateBuyer: "ยืนยันการแก้ไขลูกหนี้การค้าหรือไม่ ?",
    createSucess: "กำหนดลูกหนี้การค้าเรียบร้อย",
    updateSucess: "แก้ไขลูกหนี้การค้าเรียบร้อย",
    notfoundbuyer: "ไม่พบข้อมูลลูกหนี้การค้า",
    confirmImport: "ยืนยันการนำเข้าใบแจ้งหนี้ หรือไม่ ?",
    confirmImportAt: "ยืนยันการนำเข้าเอกสารแนบ หรือไม่ ?",
    nofilewrongtype: "ไม่มีไฟล์ หรือ ไฟล์ผิดประเภท",
    pleseinputdata: "กรุณากรอกข้อมูลให้ครบ",
    pleseinputdata2: "กรุณากรอกข้อมูลให้ครบหรือ\nตรวจสอบข้อมูลใหม่",
    removeInvoice: "ยืนยันการเพิกถอนกลุ่มใบแจ้งหนี้ หรือไม่ ?",
    removeInvoice2: "ยืนยันการเพิกถอนใบแจ้งหนี้ หรือไม่ ?",
    removeInvoice3: "ยืนยันการลบใบแจ้งหนี้ หรือไม่ ?",
    removeInvoice4: "ยืนยันการเพิกถอนใบลดหนี้ หรือไม่ ?",
    removeDebit: "ยืนยันการลบใบลดหนี้ หรือไม่ ?",
    confirmRemoveAttachment: "ยืนยันการลบเอกสารแนบ ?",
    confirmRemoveInvoice: "ยืนยันการลบใบแจ้งหนี้ ?",
    canclePosted: "ยืนยันการร้องขอการยกเลิกสถานะ POSTED หรือไม่ ?",
    canclecancel: "ยืนยันการยกเลิกสถานะ CANCEL หรือไม่ ?",
    updateInvoice: "ยืนยันการเปลี่ยนข้อมูลใบแจ้งหนี้ หรือไม่ ?",
    updateCdn: "ยืนยันการเปลี่ยนข้อมูลใบลดหนี้ หรือไม่ ?",
    confirmimportitem: "ยืนยันการนำเข้าใบแจ้งหนี้ ",
    confirmimportitemcdn: "ยืนยันการนำเข้าใบลดหนี้",
    confirmimportitem2: " รายการหรือไม่ ?",
    nogroupreject: "ขณะนี้ยังไม่รองรับการทำงานแบบ reject ทั้งกลุ่ม",
    nogroupapprove: "ขณะนี้ยังไม่รองรับการทำงานแบบ approve ทั้งกลุ่ม",
    updatenotification: "ยืนยันการเปลี่ยนสถานะการแจ้งเตือน",
    enterbranch: "กรุณาใส่เลขที่สาขาให้ครบ 5 หลัก",
    repeatuser:
      "ไม่สามารถเพิ่มผู้รับได้ เนื่องจากมีผู้รับดังกล่าวอยู่ในรายการอยู่แล้ว",
    confirmupload: "ยืนยันการอัพโหลดไฟล์",
    filemax: "เฉพาะไฟล์ PDF ไม่เกิน 50 MB. เท่านั้น",
    deft: "เพิ่มหนี้/ลดหนี้",
    endupload: " หรือไม่ ?",
    onlyexcel: "รองรับเฉพาะไฟล์ Excel (.xlsx) เท่านั้น",
    removeinvoicesuccess: "ลบใบแจ้งหนี้สำเร็จ",
    removeCDNsuccess: "ลบใบลดหนี้สำเร็จ",
    updatesuccess: "แก้ไขข้อมูลสำเร็จ",
    importsuccess: "นำเข้าใบแจ้งหนี้เรียบร้อย",
    importsuccesscdn: "นำเข้าใบลดหนี้เรียบร้อย",
    onlypdfxml: "รองรับเฉพาะไฟล์ (.xlsx .xls .doc .docx .pdf) เท่านั้น",
    updatedeft: "ยืนยันการกำหนดมูลค่าใหม่ หรือไม่",
    removedeft: "ยืนยันการลบใบเพิ่มหนี้/ลดหนี้ ",
    addbuyersuccess: "เพิ่มลูกหนี้การค้าสำเร็จ",
    updatebuyersuccess: "อัปเดตลูกหนี้การค้าสำเร็จ",
    someerror: "มีข้อมูลผิดพลาด",
    editinvoice: "แก้ไขใบแจ้งหนี้ ",
    editcdn: "แก้ไขใบลดหนี้ ",
    removeInvoicePermission:
      "ไม่สามารถลบข้อมูลที่นำเข้าจากระบบ e-tax Invoice & e-reciept ได้",
    importFileInvoiceFail:
      "ไม่สามารถแนบไฟล์ใบแจ้งหนี้ได้ เนื่องจากรูปแบบไฟล์ไม่ถูกต้อง",
    importFileAttachmentFail:
      "ไม่สามารถแนบไฟล์ได้ เนื่องจากรูปแบบไฟล์ไม่ถูกต้อง",
    importFileInvoiceFailcdn:
      "ไม่สามารถแนบไฟล์ใบลดหนี้ได้ เนื่องจากรูปแบบไฟล์ไม่ถูกต้อง",
    importFileAttachmentFailcdn:
      "ไม่สามารถแนบไฟล์ได้ เนื่องจากรูปแบบไฟล์ไม่ถูกต้อง",
  },
  table: {
    nodata: "ไม่มีข้อมูล",
    itemsPerPage: "จำนวนแสดงผล",
    loading: "กำลังโหลดข้อมูล",
  },
  btn: {
    search: "ค้นหา",
    clear: "เคลียร์",
    close: "ปิด",
    back: "ย้อนกลับ",
    importinvoice: "นำเข้าใบแจ้งหนี้",
    importcdn: "นำเข้าใบลดหนี้",
    import: "นำเข้า",
    add: "เพิ่มข้อมูล",
    edit: "แก้ไขข้อมูล",
    cancel: "ยกเลิก",
    addbuyer: "เพิ่มลูกหนี้การค้า",
    save: "บันทึก",
    remove: "ลบ",
    open: "เปิด",
    upload: "นำเข้า",
    filter: "ตัวกรอง",
    download: "ดาวน์โหลด",
    importbyexcel: "นำเข้าด้วย Excel",
    create: "สร้าง",
    downloadAll: "ดาวน์โหลดทั้งหมด",
    editCredit: "บันทึกการแก้ไขข้อมูล",
  },
  rules: {
    taxid: "เลขผู้เสียภาษีต้อง 5 หรือ 13 หลัก",
    thai: "ไม่สามารถใช้สระหรือช่องว่างขึ้นต้นประโยคได้",
    poref: 'กรุณากรอกเลขที่ใบสั่งซื้อหรือไม่มีมีข้อมูลกรอก "-"',
    enteremail: 'โปรดระบุอีเมล หากไม่มีกรุณากรอก " - " ',
    enterdate: "กรุณาเลือกวันที่",
    onlypdf3: "*รองรับเฉพาะไฟล์ PDF เท่านั้น ขนาดไม่เกิน 3 MB",
    onlypdf: "*รองรับเฉพาะไฟล์ PDF เท่านั้น ขนาดไม่เกิน 50 MB",
    onlypdfxls: "***รองรับเฉพาะไฟล์ xlsx xls pdf เท่านั้น ขนาดไม่เกิน 50 MB",
    pnlypdfinvoic:
      "*รองรับเฉพาะไฟล์ PDF เท่านั้น ขนาดไม่เกิน 10 MB จำนวน 1 ไฟล์",
    pnlypdfother:
      "*รองรับเฉพาะไฟล์ PDF เท่านั้น ขนาดไม่เกิน 10 MB ต่อไฟล์ จำนวนสูงสุด 3 ไฟล์",
    enteraddress: "กรุณากรอกที่อยู่",
    enteragency: "กรุณาเลือกประเภทหน่วยงาน",
    enterbuyername: "กรุณากรอกชื่อลูกหนี้การค้า",
    name_en: "กรอกได้เฉพาะภาษาอังกฤษ",
    mail: "รูปแบบไม่ถูกต้อง กรุณากรอกตามตัวอย่าง เช่น sam@sam.com, me@me.com, test@test.com",
    mail2:
      "รูปแบบไม่ถูกต้อง กรุณากรอกตามตัวอย่าง เช่น sam@gmail.com, me@outlook.co.th",
    selectcustomertype: "กรุณาเลือกประเภทหน่วยงาน",
  },
  label: {
    branch: "เลขที่สาขา",
  },
  etaxPage_lang: {
    title: "e-Tax Invoice & e-Receipt",
    suggestion1:
      "ผู้ใช้บริการสามารถนำข้อมูลใบกำกับภาษีอิเล็กทรอนิกส์ (e-Tax Invoice) ยื่นไปยังกรมสรรพากรได้",
    suggestion2: "ผ่านการให้บริการ INET e-Tax Invoice & e-Receipt",
    register: "ลงทะเบียนใช้งาน",
    mark: "ในกรณีที่ลูกค้ามีบัญชีผู้ใช้กับ INET e-Tax Invoice แล้วให้นำ Usercode และ Access Key ของ INET e-Tax Invoice มาไว้ด้านล่าง",
    verify: "ยืนยัน Usercode และ Access Key สำหรับระบบ e-Tax",
    confirm: "ยืนยัน",
    cancel: "ยกเลิก",
    remark1: "หมายเหตุ :",
    remark2:
      "ถ้าต้องการจะเปลี่ยน Usercode หรือ Accesskey คุณสามารถกลับมายืนยัน Usercode และ Accesskey ใหม่ในหน้านี้ได้",
  },
  page_invoice_manage: {
    title: "อัปเดตสถานะใบแจ้งหนี้",
    title2: "รายการเกินกำหนดชำระ",
    customer: "ลูกค้า",
    case: " รายการ",
    btnFilters: "ตัวกรอง",
    search: "ค้นหา",
    btnDisburment: "จดหมายแจ้งโอนสิทธิ",
    btnUpdateStatus: "อัปเดตสถานะใบแจ้งหนี้",
    btnHistory: "ประวัติการทำรายการ",
    textUpdate: "อัปเดตสถานะใบแจ้งหนี้",
    show: "คลิก เพื่อดูสถานะเอกสาร",
    menuUpdate: {
      menu1: "เปลี่ยนสถานะ Financed",
      menu2: "เปลี่ยนสถานะ Paid",
      menu3: "ส่งคำขอสถานะ Indisputed",
      menu4: "เปลี่ยนสถานะ Indisputed",
      menu5: "เปลี่ยนสถานะ Rejected",
    },
    menuManage: {
      menu1: "เพิ่มหนี้/ลดหนี้",
      menu2: "ดาวน์โหลดใบแจ้งหนี้",
      menu3: "แก้ไขอัตรารับซื้อ",
    },
    filters: {
      title: "เงื่อนไขในการค้นหา",
      buyerName: "ชื่อลูกหนี้การค้า",
      p_buyerName: "เลือกชื่อลูกหนี้การค้า",
      invoiceId: "เลขที่กลุ่มใบแจ้งหนี้",
      p_invoiceId: "กรุณาระบุเลขที่กลุ่มใบแจ้งหนี้",
      docId: "เลขที่ใบแจ้งหนี้",
      p_docId: "กรุณาระบุเลขที่ใบแจ้งหนี้",
      startdate: "วันที่ดำเนินการ",
      issuedate: "วันที่ใบแจ้งหนี้",
      duedate: "วันกำหนดชำระ",
      to: "ถึง",
      status: "สถานะ",
      allStatus: "ทุกสถานะ",
      amount: "ยอดเงิน",
      bath: "บาท",
      btnClear: "เคลียร์",
      btnSearch: "ค้นหา",
    },
    headerTable: {
      startdate: "วันที่ดำเนินการ",
      groupId: "เลขที่กลุ่มใบแจ้งหนี้",
      invoiceId: "เลขที่ใบแจ้งหนี้",
      buyerName: "ชื่อลูกหนี้การค้า",
      transaction: "จำนวนใบแจ้งหนี้",
      amount: "รวมยอดทั้งหมด(บาท)",
      actual_amount: "ยอดรับซื้อจริง",
      purchaseRate: "อัตราการรับซื้อ",
      status: "สถานะ",
      statusInvoice: "สถานะเอกสาร",
      confirm: "การยืนยัน",
      manage: "จัดการ",
      file: "ใบปะหน้า",
      download: "ดาวน์โหลด Invoice",
      duedate: "กำหนดชำระ",
    },
    dialogHeader: {
      menu1: "การกระทำ",
      menu2: "วันที่ผู้ขอสินเชื่อดำเนินการ",
      menu3: "ผู้ขอสินเชื่อ",
      menu4: "วันที่ผู้ให้สินเชื่อดำเนินการ",
      menu5: "ผู้ให้สินเชื่อ",
    },
  },
  page_account: {
    title: "บัญชีลูกค้า",
    create_btn: "สร้างบัญชีลูกค้า",
    case: "รายการ",
    search: "ค้นหา",
    no_data: "ไม่มีข้อมูล",
    showing: "จำนวนทั้งหมด",
    id: "รหัสลูกค้า",
    name: "ชื่อลูกค้า",
    tax_id: "เลขประจำตัวผู้เสียภาษี",
    contract_id: "เลขที่สัญญา",
    amount: "วงเงินสัญญา",
    total: "วงเงินคงเหลือ",
    status: "สถานะ",
    all: "ทั้งหมด",
    swl_title: "ไม่มีสิทธิ์ใช้งาน",
    swl_text: "คุณไม่มีสิทธิ์เข้าเข้าถึงการสร้างบัญชีลูกค้า",
    swl_sc: "",
    swl_er: "ดำเนินการไม่สำเร็จ",
  },
  page_admin: {
    log_title: "บันทึกกิจกรรม",
    log_search: "ค้นหากิจกรรม",
    log_clear: "เคลียร์",
    log_sort: "ตัวกรอง",
    log_date: "วันที่และเวลา",
    log_user: "ผู้ใช้",
    log_type: "หมวดหมู่",
    log_act: "กิจกรรม",
    log_invoice: "เลขที่เอกสาร",
    log_date_from: "วัน/เดือน/ปี",
    log_date_to: "ถึง",
    count: "จำนวนแสดงผล",
    from: "จาก",
    no_data: "ไม่พบข้อมูล",
    per_title: "กำหนดสิทธิ",
    per_pic: "รูปภาพ",
    per_name: "ชื่อ-นามสกุล",
    per_one: "OneID",
    per_type: "ประเภทพนักงาน",
    per_pos: "ตำแหน่ง",
    per_per: "กำหนดสิทธิ",
    per_super: "ผู้ดูแลระบบ",
    role_title: "จัดการบทบาท",
    role_title2: "สร้างบทบาท",
    role_name: "ชื่อบทบาท",
    role_btn: "เพิ่มบทบาท",
    role_number: "จำนวนผู้ใช้บทบาท",
    role_mange: "จัดการ",
    addrole_cancel: "ยกเลิก",
    addrole_addbtn: "เพิ่มบทบาท",
    addrole_editbtn: "บันทึก",
    addrole_sub: "รายละเอียดบทบาท",
    addrole_name: "ชื่อบทบาท",
    addrole_v: "ดูเท่านั้น",
    addrole_d: "ดาวน์โหลดข้อมูล",
    addrole_ced: "สร้าง/แก้ไข/ลบ",
    addrole_a: "ผู้อนุมัติ",
    add_swl1: "ยืนยันการเพิ่มบทบาทหรือไม่ ?",
    add_swl2: "ยืนยัน",
    add_swl3: "ยกเลิก",
    add_swl4: "ดำเนินการสำเร็จ",
    add_swl5: "เพิ่มบทบาทเรียบร้อย",
    add_swl6: "ดำเนินการไม่สำเร็จ",
    add_swl7: "กรุณากรอกชื่อบทบาท",
    add_swl8: "ต้องการยกเลิกการเพิ่มบทบาทหรือไม่ ?",
    edit_swl1: "ยืนยันการแก้ไขหรือไม่ ?",
    edit_swl2: "ต้องการยกเลิกการแก้ไขบทบาทหรือไม่ ?",
    edit_swl3: "แก้ไขบทบาทเรียบร้อย",
    rca_title: "จัดการใบรับรองอิเล็กทรอนิกส์",
    rca_menu: "ขอใบรับรองอิเล็กทรอนิกส์",
    list: {
      list1: "บัญชีลูกค้า/ลูกหนี้การค้า",
      list2: "สร้างเลขที่กลุ่มใบแจ้งหนี้",
      list3: "สร้างจดหมายโอนสิทธิ",
      list4: "นำเข้าใบแจ้งหนี้",
      list5: "รายการโอนสิทธิ (ใบแจ้งหนี้)",
      list6: "อัปเดตสถานะ Finance/Reject",
      list7: "อัปเดตสถานะ Paid/Indisputed",
      list8: "รายงาน",
    },
  },
  page_disbursement: {
    title: "รายการโอนสิทธิเรียกร้อง (ใบแจ้งหนี้)",
    detailSort: "วันที่ใบแจ้งหนี้",
    customer: "ลูกค้า",
    click: "คลิก เพื่อดูสถานะเอกสาร",
    disabled: "คุณไม่มีสิทธิ์ใช้งาน กรุณาติดต่อผู้ดูแลระบบ",
    list: "รายการ",
    search: "ค้นหา",
    noData: "ไม่มีข้อมูล",
    issue_date: "วันที่ดำเนินการ",
    business_name: "ชื่อลูกค้า",
    transaction: "จำนวนสิทธิเรียกร้อง",
    amount: "รวมยอดทั้งหมด(บาท)",
    purchase_rate: "อัตราการรับซื้อ",
    status: "สถานะ",
    managedata: "จัดการข้อมูล",
    option_name: ["ลงทะเบียน", "ยกเลิกใบแจ้งหนี้", "รายละเอียด"],
  },
  page_report: {
    report: "รายงาน",
    search_conditions: "เงื่อนไขในการค้นหา",
    customer: "ลูกค้า",
    name: "ชื่อลูกหนี้การค้า",
    invoice_number: "เลขที่ใบแจ้งหนี้",
    invoice_group_number: "เลขที่กลุ่มใบแจ้งหนี้",
    execution_date: "วันที่ดำเนินการ",
    to: "ถึง",
    document_date: "วันที่เอกสาร",
    due_date: "วันกำหนดชำระ",
    status: "สถานะ",
    clear: "เคลียร์",
    search: "ค้นหา",
    download_report: "ดาวน์โหลดรายงาน",
    list: "รายการ",
    no_data: "ไม่มีข้อมูล",
    click: "คลิก เพื่อดูสถานะเอกสาร",
    disabled: "คุณไม่มีสิทธิ์ใช้งาน กรุณาติดต่อผู้ดูแลระบบ",
    data_table: {
      last_update: "วันที่ดำเนินการ",
      doc_id: "เลขที่กลุ่มใบแจ้งหนี้",
      invoice_id: "เลขที่ใบแจ้งหนี้",
      buyer_name: "ชื่อลูกหนี้การค้า",
      amount: "จำนวนเงิน",
      purchase_rate: "อัตราการรับซื้อ",
      issue_date: "วันที่เอกสาร",
      due_date: "กำหนดชำระ",
      status: "สถานะ",
    },
  },
  page_consider: {
    title: "พิจารณาสินเชื่อเบื้องต้น",
    btnCheck: "ตรวจสอบสถานะการขอสินเชื่อ",
    tab1: "ข้อมูลทั่วไป",
    tab2: "นำส่งใบแจ้งหนี้",
    subtt1: "ข้อมูลทั่วไป",
    subtt2: "ข้อมูลติดต่อ",
    sellername: "ชื่อกิจการ",
    branch: "สาขา",
    type: "ลักษณะธุรกิจ",
    r_type: "กรุณากรอกลักษณะธุรกิจ",
    regisCap: "ทุนจดทะเบียน",
    r_regisCap: "ระบุทุนจดทะเบียน",
    regisDate: "วันที่จดทะเบียน",
    r_regisDate: "กรุณาเลือกวันที่จดทะเบียน",
    aveBill: "รายได้ต่อบิล",
    r_aveBill: "ระบุรายได้ต่อบิล",
    monthIn: "รายได้เฉลี่ยนต่อเดือน",
    r_monthIn: "ระบุรายได้ต่อเดือน",
    partner: "ลักษณะธุรกิจคู่ค้า",
    r_partner: "ระบุลักษณะธุรกิจคู่ค้า",
    interestedCredit: "สินเชื่อที่สนใจ",
    r_interestedCredit: "กรุณาเลือกสินเชื่อที่สนใจ",
    r_contactPerson: "ระบุชื่อผู้ติดต่อ",
    position: "ตำแหน่ง",
    r_contactTel: "ระบุหมายเลขติดต่อ",
    btnSave: "บันทึก",
    swalSuccess: "บันทึกข้อมูลเรียบร้อย",
    swalErr: "ดำเนินการไม่สำเร็จ",
    swalErrText: "กรุณากรอกข้อมูลให้เรียบร้อย",
    btnSent: "นำส่งข้อมูล",
  },
  credit: {
    creditId: "เลขที่เอกสาร",
    creditIdLabel: "กรุณากรอกเลขที่เอกสาร",
  },
};
